import { useContext, useEffect, useState } from 'react';
import './FavouritesPage.scss';
import moment from 'moment';
import { useSelector } from 'react-redux';
import request from '../../request';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faHeart, faHeartCircleCheck, faPersonWalking } from '@fortawesome/free-solid-svg-icons';
import ThemeContext from '../../context/themeProvider';

const FavouritesPage = (props) => {
  const [data, setData] = useState([]);
  const [favouritePlaces, setFavouritePlaces] = useState([]);
  const { theme } = useContext(ThemeContext);

  const geolocation = useSelector((state) => state.app.geolocation);

  useEffect(() => {
    const storedData = localStorage.getItem('favourite-places-data');

    if (storedData) {
      setData(JSON.parse(storedData));
    }

    const storedFavouritePlaces = localStorage.getItem('favourite-places');

    if (storedFavouritePlaces) {
      setFavouritePlaces(JSON.parse(storedFavouritePlaces));
    } else {
      setFavouritePlaces([]);
    }
  }, []);

  function calculateDistance(lat1, lon1, lat2, lon2) {
    const earthRadius = 6371000; // meters
    const lat1Radians = lat1 * Math.PI / 180;
    const lon1Radians = lon1 * Math.PI / 180;
    const lat2Radians = lat2 * Math.PI / 180;
    const lon2Radians = lon2 * Math.PI / 180;
  
    const deltaLat = lat2Radians - lat1Radians;
    const deltaLon = lon2Radians - lon1Radians;
  
    const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2);
    const b = Math.cos(lat1Radians) * Math.cos(lat2Radians) * Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
  
    const c = 2 * Math.atan2(Math.sqrt(a + b), Math.sqrt(1 - a - b));
  
    const distance = earthRadius * c;
  
    return distance;
  }

  return (
    <div className={`FavouritesPage view ${theme}`}>
      {
        data.length === 0 && <div style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          No favourites places yet
        </div>
      }

      {
        data.map((place, i) => {
          let rating = place.rating;

          if (typeof rating !== 'undefined') {
            rating = parseFloat(rating).toFixed(1).replace('.', ',');
          }

          let address = place.shortFormattedAddress.split(',');

          if (address.length > 1) {
            address = address.slice(0, -1).join(',');
          }

          let todaysHours;
          if (typeof place.regularOpeningHours !== 'undefined') {
            moment.locale(geolocation.languageCode);
            todaysHours = place.regularOpeningHours.weekdayDescriptions[moment().weekday()];
          }

          const phoneNumber = place.nationalPhoneNumber || place.internationalPhoneNumber;

          let distance;

          if (geolocation.latitude !== null && geolocation.longitude !== null) {
            distance = calculateDistance(geolocation.latitude, geolocation.longitude, place.location.latitude, place.location.longitude);

            if (distance >= 1000) {
              distance /= 1000;
              distance = distance.toFixed(2).replace('.', ',');
              distance += ' χιλ/μετρα';
            } else {
              distance = Math.round(distance);
              distance += ' μέτρα';
            }
          }

          return (
            <div
              key={i}
              className="business"
            >
              <div
                className="btn-favourite"
                onClick={() => {
                  const fp = favouritePlaces.slice();
                  let fpd = localStorage.getItem('favourite-places-data');

                  if (fpd) {
                    fpd = JSON.parse(fpd);
                  } else {
                    fpd = []
                  }

                  if (favouritePlaces.includes(place.id)) {
                    const index = fp.indexOf(place.id);
                    fp.splice(index, 1);
                    fpd.splice(index, 1);
                  } else {
                    fp.push(place.id);
                    fpd.push(place);
                  }

                  setFavouritePlaces(fp)
                  localStorage.setItem('favourite-places', JSON.stringify(fp));
                  localStorage.setItem('favourite-places-data', JSON.stringify(fpd));
                }}
              >
                {
                  favouritePlaces.includes(place.id)
                    ? <FontAwesomeIcon icon={faHeartCircleCheck} size="lg"></FontAwesomeIcon>
                    : <FontAwesomeIcon icon={faHeart} size="lg"></FontAwesomeIcon>
                }
              </div>
              <div className={`photo-large`} style={{ backgroundImage: `url('${request.origin}data/places/images/${place.id}-1.png')` }}></div>
              
              <div className="details">
                <div className="header">
                  <div className="title">
                    <div className="name" style={{marginLeft: 0}}>{place.displayName.text}</div>
                  </div>

                  <div className={`rating ${parseInt(rating) > 0 ? '' : 'hidden'}`}>
                    <span className="icon">&#9733;</span>
                    <span>{rating}</span>
                  </div>
                </div>

                <div className="other-details">
                  {
                    place.primaryTypeDisplayName && <div className="type">{place.primaryTypeDisplayName.text}</div>
                  }

                  <a
                    href={`${`https://search.google.com/local/reviews?placeid=${place.id}&lang=${geolocation.languageCode}`}`}
                    target="_blank"
                    className={`review-count ${typeof place.userRatingCount !== 'undefined' ? '' : 'hidden'}`}
                  >
                    {parseInt(place.userRatingCount).toLocaleString().replace(/,/, '.')} Αξιολογήσεις
                  </a>
                </div>

                <div className="contact-details">
                  <a href={place.googleMapsUri} target="_blank" className="address" style={{ flex: 1.5 }}>{address}</a>

                  {
                    typeof phoneNumber !== 'undefined' && <div className={`phone`}>
                      <a href={`tel:${phoneNumber.replace(/ /g, '')}`}>
                        Τηλ:&nbsp;{phoneNumber}
                      </a>
                    </div>
                  }
                </div>

                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px'}}>
                  {
                    typeof todaysHours !== 'undefined' && <div className="working-hours">
                      <span className="title">ΣΗΜΕΡΑ</span>

                      <div className="items">
                        <span>
                          {todaysHours}
                        </span>
                      </div>
                    </div>
                  }
                  <div>{place.price_level}</div>
                </div>

                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px'}}>
                  <div className="directions">
                    <span>Οδηγίες</span>

                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${place.location.latitude + '%2C' + place.location.longitude}&destination_place_id=${place.id}&travelmode=walking`} target="_blank" className="text">
                      <FontAwesomeIcon icon={faPersonWalking} size="lg" />
                    </a>
                    
                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${place.location.latitude + '%2C' + place.location.longitude}&destination_place_id=${place.id}&travelmode=driving`} target="_blank" className="text">
                      <FontAwesomeIcon icon={faCar} size="lg" />
                    </a>
                  </div>

                  <span className="distance">{distance}</span>
                </div>
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

export default FavouritesPage;
